<template>
    <div class="maincontainer">
        <div class="maincolumn">
            <div class="alert error" v-if="errors.length" data-error_fields="errors.join(',')">
                <div class="title">{{ trans("Sommige adresgegevens onder 'Mijn Organisatie' ontbreken nog.") }}</div>
            </div>

            <div class="Heading">
                <div class="left">
                    <h1 class="h1">{{ trans(pageTitle) }}</h1>
                </div>
                <div class="right">
<!--                    Settings button?-->
                </div>
            </div>
            <div class="error" v-if='unauthorized || (typeof contact === "undefined")'>
                {{ trans("Het lijkt erop dat uw account niet gekoppeld is aan een contact- of bedrijfsprofiel.")}}<br>
                {{ trans("Mocht dit probleem aanhouden, neem dan contact op met de beheerder.") }}
            </div>
            <div v-else class="Block Widget Overview">
                <div class="Quicklinks">
                    <button v-for="quicklink in env('quicklink')" class="Quicklink useHand" type="button" @click.prevent="handleClick(quicklink.name)">
                        <icon :name="quicklink.icon" />
                        <div class="Heading">
                            <div class="title">{{ trans(quicklink.title) }}</div>
                            <div class="subtitle">{{ trans(quicklink.subtitle) }}</div>
                        </div>
                    </button>
                </div>
                <div class="Grid block-grid">
                    <div class="Item Medium Profile" v-if="dashboard_visible('Profile')">
                        <div class="avatar">
                            <figure>
                                <img v-if="user_avatar()" :src="user_avatar()" alt="" />
                                <Icon v-else name="profile" />
                            </figure>
                        </div>
                        <div class="heading">{{ trans("Welkom") }} {{ value(contact, env("variables.contact.properties.fullname") ) }}</div>
                        <nav>
                            <button class="more" type="button" @click.prevent="handleClick('Dashboard profile')">
                                <div class="title">{{ trans("%s bewerken", trans("Profiel")) }}</div>
                            </button>
                        </nav>
                    </div>
                    <div class="Item Medium Support" v-if="dashboard_visible('Support')">
                        <Icon name="support" />
                        <div class="heading">{{ trans("Hoe kunnen we je helpen?") }}</div>
                        <nav>
                            <a v-if="theme('phone')" :href="`tel:${phonenumber(theme('phone'))}`" class="more bg3" target="_blank">
                                <div class="title">{{ trans("Bellen") }}</div>
                            </a>
                            <a v-if="theme('email')" :href="`mailto:${theme('phone')}`" class="more outline" target="_blank">
                                <div class="title">{{ trans("Mailen") }}</div>
                            </a>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {defineComponent, inject, watch, computed} from "vue";

import Icon from "components/icon";
import trans from "helpers/_translation";
import { contact, company, value, user_avatar, unauthorized, portalStore } from "store/portal";
import { theme, env } from "config";
import { view_configuration } from "store/view";

import { useRoute, useRouter } from "vue-router";
import { phonenumber } from "helpers/_theme";

export default defineComponent({
    name: "dashboardView",
    components: {
        Icon
    },
    setup() {
        const route = useRoute();
        const router = useRouter();

        const pageTitle = computed(() => {
            return view_configuration(route.name)?.title ?? "";
        });

        const handleClick = (name, query = {}) => {
            router.push({
                name: name,
                query: query
            });
        };

        const dashboard_visible = (name) => {
            return computed(() => {
                if (env("dashboard")) {
                    return env("dashboard").some(a => a.name === name);
                }
                return false;
            }).value;
        };

        // "company_mandatory_properties": [
        //     "facturatiegegevens_straathuisnummer",
        //     "facturatiegegevens_postcode",
        //     "facturatiegegevens_plaats",
        //     "facturatiegegevens_land",
        //     "distributor_addresssame"
        // ],
        //     "company_mandatory_switch": "distributor_addresssame",
        //     "company_mandatory_switch_properties": [
        //     "distributor_addressname",
        //     "distributor_delivery_streetnr",
        //     "distributor_delivery_postalcode",
        //     "distributor_delivery_place",
        //     "distributor_delivery_country"
        // ],
        const company_mandatory_properties = computed(() => {
            return env("company_mandatory_properties") || [];
        });
        const company_mandatory_switch = computed(() => {
            return env("company_mandatory_switch") || "";
        });
        const company_mandatory_switch_properties = computed(() => {
            return env("company_mandatory_switch_properties") || [];
        });

        const errors = computed(() => {
            if (!company_mandatory_properties.value) {
                // Since we don't have any mandatory properties, we return an empty array
                return [];
            }
            // Within company.value check if the properties are present
            const result = [];
            company_mandatory_properties.value.forEach(property => {
                if (!value(company.value, property)) {
                    result.push(property)
                }
            });
            if (!result.length && (value(company.value, company_mandatory_switch.value) !== "Yes")) {
                // Check if company_mandatory_switch.value === "N"
                company_mandatory_switch_properties.value.forEach(property => {
                    if (!value(company.value, property)) {
                        result.push(property);
                    }
                });
            }
            return result;
        });


        return {
            env,
            theme,
            phonenumber,

            value,

            trans,
            pageTitle,

            portalStore,
            unauthorized,
            contact,
            user_avatar,

            dashboard_visible,

            handleClick,

            errors
        }
    }
});
</script>
